import AuthRoute from './AuthRoute';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

export default function KYCRoute({ path, render }) {
  const associates = useSelector((state) => state.associates);

  // Este render se pasará a AuthRoute
  const wrappedRender = (props) => {
    const kycStatus = associates.user?.kycStatus;

    if (kycStatus === 'INVALID' || kycStatus === 'PENDING' || kycStatus === 'REVALIDATION') {
      return <Redirect to={{ pathname: '/kyc-start' }} />;
    }

    return render(props);
  };

  return <AuthRoute path={path} render={wrappedRender} />;
}
